// extracted by mini-css-extract-plugin
export var assumptionsList = "cp_jH";
export var assumptionsTitle = "cp_jG";
export var disclosures = "cp_jB";
export var disclosuresBody = "cp_jD";
export var disclosuresSummary = "cp_jC";
export var productDisclaimer = "cp_jF";